import Axios from "axios";
import store from "../store"
import http from "./http";

const CALLTAX_AUTH_URL = 'https://calltax.kr/backend/portal/join/checkWecakeApi.do'
const CALLTAX_CLIENT_ID = "LLOK-2G4J-42OP-DHCW"
const CALLTAX_CONNECTION_URL = "https://calltax.kr/portal/wecake/"
const CALLTAX_USER_ID_PREFIX = "wecakeCP"

export const callTaxConnection = async () => {
  try {
    // Calltax API 호출

    const comapnyInfo = store.getState().Profile.company

    const wcUserId = `${CALLTAX_USER_ID_PREFIX}${comapnyInfo.idx}`
    const response = await Axios.post(
      CALLTAX_AUTH_URL
      , {
        clientId: CALLTAX_CLIENT_ID,
        wcUserId,
        wcUserNm: comapnyInfo.name || 'NULL',
        wcUserHp: comapnyInfo.phone || '01000000000',
        wcUserMail: comapnyInfo.taxEmail || 'wecake@wecake.we',
      }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // 성공 응답 처리
    if (response.data._resultCode_ === "success") {
      const authCode = response.data.item;
      // 성공 후 새창에서 Calltax URL 호출
      window.open(`${CALLTAX_CONNECTION_URL}${wcUserId}/${authCode}`, '_blank');
      http.put(`/companies/calltax-id`, {
        companyIdx: comapnyInfo.idx,
        calltaxId: wcUserId
      })
    } else {
      // 오류 메시지 표시
      alert("로그인 실패: " + response.data._msg_);
    }
  } catch (error) {
    console.error('Calltax API 호출 중 오류 발생:', error);
    alert("로그인 처리 중 오류가 발생했습니다. 관리자에 문의해주세요.");
  }
}

export default callTaxConnection